import en from 'json-loader!yaml-loader!./en.yml'

export default { en }
